module.exports = __webpack_public_path__ + "img/burger-hero-mobile.282baeaf.png";